import clsx from 'clsx';

import { TextSkeleton } from '../Skeleton';
import { BreadcrumbSeparator, Breadcrumbs } from './Breadcrumbs';

/**
 * A skeleton breadcrumbs component with a pulsating animation. To be used where more appropriate then the
 * common LoadingIndicator.
 *
 * @param props.items The number of skeleton items to render.
 */
export function BreadcrumbsSkeleton(props: { items?: number; className?: string }) {
    const { items = 2, className } = props;

    return (
        <div role="status" aria-busy className={clsx('motion-safe:animate-pulse', className)}>
            <Breadcrumbs>
                {Array.from({ length: items }, (_, index) => (
                    <li className="flex gap-1 text-ui-action" key={index}>
                        <TextSkeleton className="px-2">Breadcrumb item {index + 1}</TextSkeleton>
                        {index < items - 1 ? <BreadcrumbSeparator /> : null}
                    </li>
                ))}
            </Breadcrumbs>
        </div>
    );
}
